export class TagBoxModel {
    static fromApiResponse(data) {
        return {
            // The box identity: the real tag_id once the document is migrated, otherwise whatever the caller
            // assigned. A negative id means "drawn but never saved" (plan phase js-echte-tagid).
            id:       data.tagId ?? data.id ?? null,
            left:     data.l,
            top:      data.t,
            width:    data.w,
            height:   data.h,
            level:    data.level,
            text:     data.text ?? '',
            metadata: data.metadata ? JSON.parse(data.metadata) : null,
        };
    }

    static toApiRequest(model) {
        const req = {
            l:     model.left,
            t:     model.top,
            w:     model.width,
            h:     model.height,
            level: model.level,
            text:  model.text,
        };
        if (model.metadata != null) {
            req.metadata = JSON.stringify(model.metadata);
        }
        // Only a real id is worth sending. A negative one is a local placeholder, and a box of a document that
        // has not been migrated has none at all — there the server keeps identifying the box by its geometry.
        if (model.id > 0) {
            req.tagId = model.id;
        }
        return req;
    }

    /**
     * Does this model sit at the geometry of a box the server reported ({w,h,l,t})?
     *
     * Only used to match the boxes of a freshly migrated document against their new ids. Compared at four
     * decimals because that is what the migration stores (TagRepository::COORDINATE_DECIMALS) — the values the
     * model holds come from the legacy read, which rounds the same way.
     */
    static matchesGeometry(model, box) {
        const pairs = [[model.left, box.l], [model.top, box.t], [model.width, box.w], [model.height, box.h]];
        return pairs.every(([a, b]) => {
            // A missing coordinate never matches — Number(null) would be 0 and pair a NULL box with one at zero.
            // Same rule the read side follows (TagLegacyShape::filterByGeometry).
            if (a == null || a === '' || b == null || b === '') { return false; }
            const x = Number(a), y = Number(b);
            return Number.isFinite(x) && Number.isFinite(y) && x.toFixed(4) === y.toFixed(4);
        });
    }

    static validate({ left, top, width, height, level, text }) {
        return (
            typeof left   === 'number' &&
            typeof top    === 'number' &&
            typeof width  === 'number' &&
            typeof height === 'number' &&
            (level === 1 || level === 2) &&
            typeof text   === 'string'
        );
    }
}
